import React from 'react'
import Page from 'components/LayoutComponents/Page'
import Helmet from 'react-helmet'
import MainApp from './MainApp'
import { connect } from 'react-redux'
import { saveSettings } from './MainApp/Settings/actions'

@connect(null, { saveSettings })
class Simulator extends React.Component {
  static defaultProps = {
    pathName: 'Dashboard',
    roles: [],
  }
  parseQueryParameters = (searchQuery) =>{ 
    if(!searchQuery){
      return {}
    }else{
      let queryMap = {}
      const queryItems = searchQuery.replace("?", "")
      const splitQueries = queryItems.split("&")
     
      splitQueries.forEach(item => {
          if(item){
            const keyValue = item.split("=")
            if(keyValue.length === 2){
              queryMap[keyValue[0]] = keyValue[1]
            }
          }  
      })
      return queryMap
      
    } 
  }
  componentDidMount() {
    if (window.location.href.indexOf('?')<0) {
      window.location.href = window.location.href.replace('#','?#')
    }
    let params =  this.parseQueryParameters(this.props.location.search)
    if (params && params.apiKey && params.contractCode) {
      this.props.saveSettings(params)
    }

  }

  render() {
    const props = this.props
    return (
      <Page {...props}>
        <Helmet title="Dashboard Alpha" />
        <MainApp />
      </Page>
    )
  }
}

export default Simulator



// WEBPACK FOOTER //
// ./src/modules/Simulator/index.js